import React, { Component } from 'react';
import TestTable from 'app/views/synthetics/tests/TestTable';
import TestCollection from 'app/stores/synthetics/TestCollection';
import { inject, observer } from 'mobx-react';
import LoadingSkeleton from '../../journeys/LoadingSkeleton';
import ToolResultCard from '../components/ToolResultCard';

@inject('$syn')
@observer
class SyntheticsToolResult extends Component {
  state = {
    loading: true,
    collection: new TestCollection()
  };

  populateCollection = () => {
    const { tool, $syn } = this.props;
    const { collection } = this.state;
    const { raw_result = [] } = tool;

    // raw_result contains the specific tests returned by the backend query
    // We need to find the corresponding TestModel instances from $syn.tests
    if (raw_result.length > 0) {
      const testIds = raw_result.map((test) => test.id);
      const testModels = testIds.map((id) => $syn.tests.get(id)).filter((model) => model !== undefined);

      collection.set(testModels);
    } else {
      // No results, set empty collection
      collection.set([]);
    }
  };

  componentDidMount() {
    const { $syn } = this.props;
    // load usage data after call to load test health to handle timing issues with test deserialization after cache clears
    // see https://github.com/kentik/ui-app/issues/20806

    $syn.tests
      .loadTestHealth()
      .then(() => $syn.plan.loadUsageData({ force: true }))
      .then(() => {
        // Populate collection with the specific tests from raw_result
        this.populateCollection();
        this.setState({ loading: false });
      });
  }

  render() {
    const { tool = {}, onCloseToolResult, isInlineMode } = this.props;
    const { collection, loading } = this.state;

    if (loading) {
      return <LoadingSkeleton />;
    }

    return (
      <ToolResultCard
        tool={tool}
        onCloseToolResult={onCloseToolResult}
        isInlineMode={isInlineMode}
        className="tool-result-alerts"
        title={tool.title}
        minHeight={750}
      >
        <TestTable testCollection={collection} showSelectTest={false} />
      </ToolResultCard>
    );
  }
}

export default SyntheticsToolResult;
